import React from "react";
import PropTypes from "prop-types";
import { Modal } from "@opendate-app/setlist";

const ApplySeriesDetailsModal = ({ open, eventCount, saving, onConfirm, onCancel }) => {
  const events = eventCount === 1 ? "1 event" : `${eventCount} events`;
  return (
    <Modal
      open={open}
      size="sm"
      icon={false}
      title="Apply series details to all events?"
      description={`Saves your changes, then copies this series' type, age restriction, photo and template onto all ${events} in it.`}
      confirmLabel={saving ? "Applying…" : "Apply to all events"}
      onConfirm={onConfirm}
      cancelLabel="Cancel"
      onCancel={onCancel}
      onClose={onCancel}
    >
      <p className="series-edit-hint">
        Events keep their own names unless they still match the series name, and events with sold tickets keep their
        template. Use this after adding shows to the series to bring them in line.
      </p>
    </Modal>
  );
};

ApplySeriesDetailsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  eventCount: PropTypes.number,
  saving: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default ApplySeriesDetailsModal;
